import React from 'react';
import Link from '~/components/molecule/Link';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body, Heading4, Variant } from '~/components/atom/Typography';
import TEST_ID from './index.testid';
import Catalog from '~/Catalog';
import useTrackEvent from '~/hooks/useTrackEvent';

export type Props = {};

const text = {
  title: 'Overeenkomsten',
  description:
    'Hieronder vind je alle overeenkomsten die van kracht zijn op je huidige abonnement.',
  termsAndConditionsPdf: 'Algemene voorwaarden',
  processingAgreementPdf: '(Verwerkers)overeenkomst',
};

const Agreements: React.FCC<Props> = ({ dataTestId, ...rest }) => {
  const trackEvent = useTrackEvent();

  return (
    <JustificationContainer
      data-testid={dataTestId}
      {...rest}
      direction="column"
    >
      <Heading4 variant={Variant.primary}>{text.title}</Heading4>
      <Body size="base">{text.description}</Body>
      <JustificationContainer direction="column" gap="s">
        <Link
          to="https://dhstash.s3.eu-west-1.amazonaws.com/DatHuis+(verwerkers)overeenkomst+v20241118.pdf"
          target="_blank"
          download={`${Catalog.companyName} verwerkers overeenkomst.pdf`}
          data-testid={TEST_ID.PDF_LINK_PROCESSING}
          onClick={() => {
            /** ----- TRACKING: agreement_link_clicked ----- */
            trackEvent({
              eventName: 'agreement_link_clicked',
            });
          }}
        >
          {text.processingAgreementPdf}
        </Link>
        <Link
          to="https://dhstash.s3-eu-west-1.amazonaws.com/Nederland+ICT+Voorwaarden+2014+-+NL.pdf"
          target="_blank"
          download="NederlandICTVoorwaarden.pdf"
          data-testid={TEST_ID.PDF_LINK}
          onClick={() => {
            /** ----- TRACKING: t_&_c_link_clicked ----- */
            trackEvent({
              eventName: 't_&_c_link_clicked',
            });
          }}
        >
          {text.termsAndConditionsPdf}
        </Link>
      </JustificationContainer>
    </JustificationContainer>
  );
};

export default Agreements;
